import { useState } from 'react';

interface UseAlertDialogReturn {
  showAlert: boolean;
  alertTitle: string;
  alertMessage: string;
  setAlert: (title: string, message: string) => void;
  clearAlert: () => void;
}

export function useAlertDialog(): UseAlertDialogReturn {
  const [showAlert, setShowAlert] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');

  const setAlert = (title: string, message: string) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setShowAlert(true);
  };

  const clearAlert = () => {
    setShowAlert(false);
    setAlertTitle('');
    setAlertMessage('');
  };

  return {
    showAlert,
    alertTitle,
    alertMessage,
    setAlert,
    clearAlert
  };
}